"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  'fields.site': process.env.NEXT_PUBLIC_SITE
};
exports["default"] = _default;